import Auid from './Auid';

export default Auid;
